export default __webpack_public_path__ + "static/media/factura3.3433cb71.pdf";